import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useUser } from "./Context/UserContext";
import Logo from "./ui/Logo";
import "../styles/login.css";

export default function TokenLogin() {
    const history = useHistory();
    const { loginUser } = useUser();

    useEffect(() => {
        const login = async () => {
            try {
                
                const params = new URLSearchParams(window.location.search);
                // const token = params.get("token");

                // ---- Hardcoded test token (uncomment to test locally) ----
                const token = "batl1AfhbnNCkB42naMwnW0cyTY6oRjiN-h0MfYcklWU8I10JyFuEkvtLGdvcy5sY0K2NX_fOZY_rPMDCiaitw";

                if (!token) {
                    console.error("Missing token in query string");
                    history.replace("/login");
                    return;
                }

                const res = await axios.post("/api/TokenAuth/login", { token });

                const {
                    token: jwt,
                    empId,
                    menus,
                    active,
                    roles,
                    name,
                    email,
                    doj,
                    reportingMgrId,
                    reportingMgrName
                } = res.data;

                if (!active) {
                    history.replace("/login");
                    return;
                }

                loginUser(jwt, empId, menus, {
                    name,
                    email,
                    doj,
                    roles,
                    reportingMgrId,
                    reportingMgrName
                });

                // replace: the /token-login entry (and its token) must not stay
                // in the back stack, or Back after sign-out would re-authenticate
                history.replace("/home");
            } catch (err) {
                console.error(err);
                history.replace("/login");
            }
        };

        login();
    }, [history, loginUser]);

    return (
        <div className="login-page" role="status" aria-live="polite">
            <div className="token-login-card reveal">
                <Logo size={30} showWordmark={false} />
                <span className="login-spinner token-spinner spin" aria-hidden="true" />
                <h2 className="token-login-title">Signing you in…</h2>
                <p className="token-login-sub">Verifying your session with TMS</p>
            </div>
        </div>
    );
}